// グローバルエラーハンドラー（リソース404・詳細なしは無視。undefinedは絶対に出さない）
function shouldIgnoreGlobalError(event: ErrorEvent): boolean {
  const message = typeof event.message === 'string' ? event.message : '';
  // iOS Safari 等で外部スクリプト由来のクロスオリジンエラー（詳細なし）
  if (message === 'Script error.' && (!event.filename || event.lineno === 0)) {
    return true;
  }
  if (message.includes('ResizeObserver loop')) {
    return true;
  }
  return false;
}

window.addEventListener('error', (event) => {
  if (event.target != null && event.target !== window) return;
  if (shouldIgnoreGlobalError(event)) return;
  // event.error または event.message がないと何も出さない（colno=0 等の誤検知を防ぐ）
  const hasError = event.error != null;
  const hasMessage = typeof event.message === 'string' && event.message.length > 0;
  if (!hasError && !hasMessage) return;

  const msg = hasMessage ? event.message : (hasError && event.error instanceof Error ? event.error.message : '不明なエラー');
  const safeMsg = String(msg ?? '不明なエラー');
  const detail = hasError && event.error instanceof Error
    ? (event.error.stack ?? safeMsg)
    : (event.error != null ? JSON.stringify(event.error, null, 2) : `${event.message ?? ''}\n${event.filename ?? ''}\n${event.lineno ?? ''}`);

  console.error('❌ グローバルエラー:', safeMsg);

  const rootElement = document.getElementById('root');
  if (!rootElement || rootElement.innerHTML.includes('エラーが発生しました')) return;
  rootElement.innerHTML = `
    <div style="padding: 20px; font-family: sans-serif; max-width: 800px; margin: 50px auto;">
      <h1 style="color: #dc2626;">❌ エラーが発生しました</h1>
      <p style="color: #666; margin: 20px 0;">${safeMsg}</p>
      <p style="margin-top: 20px; color: #666;">ファイル: ${event.filename ?? '不明'}</p>
      <p style="color: #666;">行: ${event.lineno ?? '不明'}</p>
      <details style="margin-top: 20px;">
        <summary style="cursor: pointer; color: #2563eb;">詳細を表示</summary>
        <pre style="background: #f5f5f5; padding: 15px; overflow: auto; margin-top: 10px; border-radius: 4px; font-size: 12px; white-space: pre-wrap;">${detail}</pre>
      </details>
      <p style="margin-top: 20px; color: #666;">ブラウザのコンソール（F12）で詳細なエラー情報を確認してください。</p>
    </div>
  `;
}, true);

window.addEventListener('unhandledrejection', (event) => {
  const r = event.reason;
  if (r == null) return; // reasonがundefined/nullの場合は何もしない
  const msg = r instanceof Error ? r.message : String(r);
  console.error('❌ 未処理のPromise拒否:', msg, r);
});

console.log('🚀 アプリケーション初期化開始...');

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './src/index.css';

console.log('✅ モジュールインポート完了');

const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('❌ root要素が見つかりません');
  throw new Error("Could not find root element to mount to");
}

console.log('✅ root要素を発見');

try {
  const root = ReactDOM.createRoot(rootElement);
  console.log('✅ ReactDOM.createRoot完了');
  
  root.render(
    React.createElement(React.StrictMode, null,
      React.createElement(App, null)
    )
  );
  console.log('✅ Reactアプリケーションのレンダリング開始');
} catch (error) {
  console.error('❌ アプリケーション初期化エラー:', error);
  rootElement.innerHTML = `
    <div style="padding: 20px; font-family: sans-serif; max-width: 800px; margin: 50px auto;">
      <h1 style="color: #dc2626;">❌ エラーが発生しました</h1>
      <p style="color: #666; margin: 20px 0;">${error instanceof Error ? error.message : String(error)}</p>
      <details style="margin-top: 20px;">
        <summary style="cursor: pointer; color: #2563eb;">詳細を表示</summary>
        <pre style="background: #f5f5f5; padding: 15px; overflow: auto; margin-top: 10px; border-radius: 4px; font-size: 12px;">${error instanceof Error ? error.stack : JSON.stringify(error, null, 2)}</pre>
      </details>
      <p style="margin-top: 20px; color: #666;">ブラウザのコンソール（F12）で詳細なエラー情報を確認してください。</p>
    </div>
  `;
}
